<div id="ht">
    <div id="main-cnt">

        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">Prodotti</span>
                    </div>
                </ion-buttons>
            </ion-toolbar>
            <br>

            <!-- edit da qui... -->

            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content overflow-auto ">

            <app-coming-soon></app-coming-soon>

        </ion-content>
    </div>
</div>
